<template>
  <bita-modal
      :id="modalId"
      :title="title"
      :modal-lg="true"
      :isLoading="isLoading"
      @close="onCloseModal"
  >
    <div slot="body" v-if="this.ownerData.model_id===null&&this.ownerData.model_type===null">
      <bita-ibox :is-loading="isLoadingModal">
        <div slot="body">
          <div class="row">
            <div class="col-lg-6 mb-1">
              <bita-select
                  ref="carrierDropDown"
                  name="carrier"
                  label="زیر مجموعه"
                  validation-container-class="col-12"
                  input-class="form-control"
                  :data-source="subcategory"
                  data-text-field="name"
                  data-value-field="id"
                  v-model="dataForm.id"
              />
            </div>
            <div class="col-lg-6 mt-4">
              <bita-bootbutton
                  type="primary"
                  title="اضافه کردن"
                  icon="fa fa-check"
                  btn-width="200px"
                  @click.native="addOwnerToSubset()"
              />
            </div>
          </div>
          <bita-ibox>
            <div slot="body">
              <div  v-if="isLoadingGrid" class="row justify-content-center" >
                <div class="col-auto">
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </div>

              <table class="table" v-else>
                <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col"> نام</th>
                  <th scope="col">تاریخ ایجاد</th>
                  <th scope="col">عملیات</th>
                </tr>
                </thead>
                <tbody>

                <tr v-for=" ( item, index ) in Subsets " :key="index" >
                  <th scope="row">{{ index+1 }}</th>
                  <td>{{ item.name }}</td>
                  <td>{{ $getJalaliDateTime(item.created_at) }}</td>
                  <td>
                    <span v-if="item.deleted_at"> حذف شده! </span>
                    <span v-else>
                        <a role='button' @click="deleteSubset(item)" title='حذف'><span class='fas fa-times' style='color:red'></span></a>
                      </span>
                  </td>
                </tr>

                </tbody>
              </table>

            </div>

          </bita-ibox>
        </div>
      </bita-ibox>
    </div>
    <div slot="body" style="text-align: center" v-else>
     کاربر مد نظر سمت فعال دارد
    </div>
    <div slot="footer"></div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: String,
    title: String,
    isLoading: Boolean,
    propsData: Object,
  },

  data() {
    return {
      data:{},
      dataForm: {},
      ownerData: {},
      subcategory: [],
      isLoadingModal: false,
      isLoadingGrid: false,
      colWidth: "col-lg-4",
      Subsets: [],
      search: ''
    };
  },

  watch: {
    propsData: function(_data){
      this.ownerData = _data;
    },
  },
  mounted() {
    this.isLoadingGrid = true;
    Promise.all([
      this.getSubcategory(),
    ]).then((res) => {
      this.subcategory = res[0].data;
    });
  },
  methods: {
    getSubcategory() {
      return this.$persistClient("get", "owners");
    },
    reset() {
      this.dataForm = {
        id:0 ,
        name: "",
        family: "",
        phone: "",
        national_code: "",
      };
    },

    readData() {
      this.isLoadingGrid = true;
      this.$persistClient("get", `users/owner?user_id=${this.ownerData.id}`)
          .then((res) => {
            this.Subsets = res.data.data;
          })
          .catch(() => {
            this.Subsets = [];
          })
          .finally(() => {
            this.isLoadingGrid = false;
          });
    },

    gridCommands() {
      let commands = [];
      commands.push({
        text: "delete",
        click: this.delete,
        template: this.gridButtons.delete,
      });
      return commands;
    },

    deleteSubset(driver) {
      this.$alert("question", `آیا از حذف  ${driver.name} اطمینان دارید ؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$persistClient(
              "delete",
              `users/owner?user_id=${this.ownerData.id}&owner_id=${driver.id}`
          )
              .then((res) => {
                this.$izitoast("success", "عملیات موفق", res.data.message);
              })
              .finally(() => {
                this.readData()
              });
        }
      });
    },
    onCloseModal() {
      this.dataForm = [];
    },

    addOwnerToSubset() {
      this.$persistClient("post", `users/owner?user_id=${this.ownerData.id}&owner_id=${this.dataForm.id}`)
          .then((res) => {
            this.$izitoast("success", "عملیات موفق", res.data.message);
          })
          .finally(() => (
              this.readData()
          ));
    },
  },
};
</script>